import React from "react";

export function FullScreenLoader({ isLoading }) {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-[4px] animate-in fade-in duration-300">
      <div className="premium-loader"></div>
    </div>
  );
}

export function TableBlurLoader({ isLoading, children, className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <div
        className={`transition-all duration-300 ${isLoading ? "blur-[6px] pointer-events-none opacity-40" : "blur-0 opacity-100"
          }`}
      >
        {children}
      </div>

      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/5 backdrop-blur-[2px] animate-in fade-in duration-300 rounded-xl">
          <div className="premium-loader"></div>
        </div>
      )}
    </div>
  );
}

const Loader = ({ className = "" }) => {
  return (
    <div className={`flex flex-col justify-center items-center ${className}`}>
      <div className="premium-loader"></div>
    </div>
  );
};

export default Loader;